<ng-container [formGroup]="formGroup">
  <div class="flex">
    @if (direction === 'column') {
      <div class="row">
        <div class="cell">
          <app-form-input [type]="'password'"
                          formControlName="password"
                          [name]="'password'"
                          [label]="'page.credential.form.label.password'"
                          [placeholder]="'page.credential.form.placeholder.password'"
                          [required]="true"
                          [autocomplete]="'off'"></app-form-input>
          <div *ngIf="formActionType === 'ADD' && passwordRequireError" class="errors">
            <span>{{ 'page.credential.form.error.password.required'|translate }}</span>
          </div>
        </div>
        <div class="cell">
          <app-form-input [type]="'password'"
                          formControlName="confirmPassword"
                          [name]="'confirmPassword'"
                          [label]="'page.credential.form.label.confirmPassword'"
                          [placeholder]="'page.credential.form.placeholder.confirmPassword'"
                          [required]="true"
                          [autocomplete]="'off'"></app-form-input>
          <div *ngIf="formActionType === 'ADD' && confirmRequireError" class="errors">
            <span>{{ 'page.credential.form.error.confirmation.required'|translate }}</span>
          </div>
          <div *ngIf="passwordMatchError" class="errors">
            <span>{{ 'page.credential.form.error.confirmation.matching'|translate }}</span>
          </div>
        </div>
      </div>
    } @else {
      <div class="row">
        <div class="cell">
          <app-form-input [type]="'password'"
                          formControlName="password"
                          [name]="'password'"
                          [label]="'page.credential.form.label.password'"
                          [placeholder]="'page.credential.form.placeholder.password'"
                          [autocomplete]="'off'"
                          [required]="true"
                          [readonly]="false"></app-form-input>
          <div *ngIf="formActionType === 'ADD' && passwordRequireError" class="errors">
            <span>{{ 'page.credential.form.error.password.required'|translate }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="cell">
          <app-form-input [type]="'password'"
                          formControlName="confirmPassword"
                          [name]="'confirmPassword'"
                          [label]="'page.credential.form.label.confirmPassword'"
                          [placeholder]="'page.credential.form.placeholder.confirmPassword'"
                          [autocomplete]="'off'"
                          [required]="true"
                          [readonly]="false"></app-form-input>
          <div *ngIf="formActionType === 'ADD' && confirmRequireError" class="errors">
            <span>{{ 'page.credential.form.error.confirmation.required'|translate }}</span>
          </div>
          <div *ngIf="passwordMatchError" class="errors">
            <span>{{ 'page.credential.form.error.confirmation.matching'|translate }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</ng-container>
